import { Controller } from "@hotwired/stimulus"

export default class IndeterminateCheckboxController extends Controller {
  static targets = ["indeterminateCheckbox", "checkbox"]

  connect() {
    if (this.hasCheckboxTarget) {
      this.updateIndeterminateCheckbox()
    } else {
      this.element.indeterminate = true
    }
  }

  updateIndeterminateCheckbox() {
    const total = this.checkboxTargets.length
    const checked = this.checkboxTargets.filter((cb) => cb.checked).length
    const someIndeterminate = this.checkboxTargets.some(
      (cb) => cb.indeterminate
    )

    if (checked === total) {
      this.indeterminateCheckboxTarget.checked = true
      this.indeterminateCheckboxTarget.indeterminate = false
    } else if (checked > 0 || someIndeterminate) {
      this.indeterminateCheckboxTarget.checked = false
      this.indeterminateCheckboxTarget.indeterminate = true
    } else {
      this.indeterminateCheckboxTarget.checked = false
      this.indeterminateCheckboxTarget.indeterminate = false
    }
  }
}
